"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = Component;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const LocalElements = __importStar(require("./elements"));
const oidc_client_ts_1 = require("oidc-client-ts");
const client_config_1 = require("../../../../client-config");
function Component(props) {
    return (React.createElement(LocalElements.StyledFieldset, null,
        React.createElement("legend", null, "Impersonation"),
        React.createElement("div", null,
            React.createElement(Elements.InputText, { value: props.input, onChange: e => {
                    props.setImpersonationInput(e.target.value);
                }, onKeyDown: e => e.keyCode === 13 &&
                    onClick(props.input, props.setShowImpersonationError) }),
            React.createElement(Elements.StandardButton, { onClick: () => onClick(props.input, props.setShowImpersonationError) }, "impersonate")),
        props.showError && React.createElement("p", null, "There was an error trying to impersonate")));
}
async function onClick(userName, setShowImpersonationError) {
    const manager = new oidc_client_ts_1.UserManager({
        authority: client_config_1.config.oidcAuthority,
        client_id: client_config_1.config.oidcClientId,
        redirect_uri: client_config_1.config.oidcRedirectUri,
        response_type: client_config_1.config.oidcResponseType,
        scope: client_config_1.config.oidcScope,
        monitorSession: false,
        loadUserInfo: false,
        automaticSilentRenew: client_config_1.config.oidcResponseType === "code"
    });
    const user = await manager.getUser();
    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + (user === null || user === void 0 ? void 0 : user.access_token)
        }
    };
    const response = await fetch(`/impersonate?username=${userName}`, options);
    if (response.ok) {
        const userResponse = await response.text();
        const user = oidc_client_ts_1.User.fromStorageString(userResponse);
        manager.storeUser(user);
        // biome-ignore lint: -
        location.reload();
    }
    else {
        setShowImpersonationError(true);
    }
}
//# sourceMappingURL=impersonation.js.map